<template>
  <div id="myDateShow">
    <div class="title">查看 农基商资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">农基商类型</div>
        <div class="value">{{merchants.merchantsClassify}}</div>
      </div>
      <div class="line">
        <div class="key">农基商名称</div>
        <div class="value">{{merchants.merchantsName}}</div>
      </div>
      <div class="line">
        <div class="key">联系人</div>
        <div class="value">{{merchants.name}}</div>
      </div>
      <div class="line">
        <div class="key">常用邮箱</div>
        <div class="value">{{merchants.email}}</div>
      </div>
      <div class="line">
        <div class="key">联系地址</div>
        <div class="value">{{merchants.address}}</div>
      </div>
      <div class="line">
        <div class="key">农基区域</div>
        <div class="value">{{merchants.detailAddress}}</div>
      </div>
      <div class="line">
        <div class="key">入驻时间</div>
        <div class="value">{{merchants.inTime}}</div>
      </div>
      <div class="line">
        <div class="key">合作协议书</div>
        <div class="value">{{merchants.agreementName}}</div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-link download="协议书" :underline="false" :href="merchants.agreementUrl">
            <el-button type="success" size="small" @click="aaa">下载协议书</el-button>
          </el-link>
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getMerchantsById,newVue} from "../../network/merchants";

  export default {
    name: "merchantsData",
    components: {},
    data(){
      return{
        merchantsId:"",
        merchants:{}
      }
    },
    methods:{
      aaa(){},
      backClick(){
        this.$router.push("../list");
      },
    },
    created() {
      newVue.obj = this;

      this.common.HeaderLocationTwo.href =  "/merchants/list";
      this.common.HeaderLocationTwo.name = "农基商资料管理"
      this.common.HeaderLocationThree.name = "农基商资料详情"
      this.merchantsId = this.$route.params.id;

      getMerchantsById(this.merchantsId).then(res => {
        this.merchants = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
</style>
